import { Component } from '@angular/core';
import { App } from 'ionic-angular';

@Component({
  selector: 'account-password',
  templateUrl: 'account-password.html'
})
export class AccountPasswordPage {
  constructor(
    public app: App
  ) {}
  ionViewDidEnter() {
    this.app.setTitle('Change Password');
  }
}


// WEBPACK FOOTER //
// ./src/pages/account-password/account-password.ts